import React from 'react';
import Carousel from './Carousel';
import AboutHome from '../pages/AboutHome';
import ServicesSlider from '../pages/ServicesSlider';
import PromoSection from '../pages/PromoSection';
import HotOffers from '../pages/HotOffers';
import TestimonialSlider from '../pages/TestimonialSlider';
import CallArea from '../pages/CallArea';
import BlogArea from '../pages/BlogArea';
import BookingForm from '../pages/BookingForm';



const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">



 <Carousel/>
 <BookingForm/>
<AboutHome/>
<ServicesSlider/>
<PromoSection/>
<HotOffers/>
<TestimonialSlider/>
<CallArea/>
<BlogArea/>

    </div>
  );
};

export default HeroSection;
